import React from "react";
import { Avatar, type AvatarProps } from "@outpave/ds";
import { fullName } from "utils/fullName";

/** The fields `USER_AVATAR_FIELDS` selects; any user-shaped record carrying them will do. */
export interface UserAvatarUser {
  firstName?: string | null;
  lastName?: string | null;
  profilePicUrl?: string | null;
}

interface UserAvatarProps extends Omit<
  AvatarProps,
  "src" | "name" | "alt" | "slotProps"
> {
  user: UserAvatarUser | null | undefined;
}

/**
 * A person's avatar: their picture, else initials from their name, first name
 * first everywhere so the same person never gets two different initials.
 */
const UserAvatar: React.FC<UserAvatarProps> = ({ user, ...rest }) => {
  const name = fullName(user) || undefined;

  return (
    <Avatar
      src={user?.profilePicUrl || undefined}
      name={name}
      alt={name}
      // Long lists only fetch the pictures that scroll into view.
      slotProps={{ img: { loading: "lazy" } }}
      {...rest}
    />
  );
};

export default UserAvatar;
